<div class="container webview text-center" [@flyInOut]="'in'">
  <div class="col-sm-12 pt-5">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub2}}</h1>
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub3}}</h1>
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub4}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub5}}</h1>
  </div>
  <div class="col-sm-12">
    <button class="btn mr-2 ml-2 combtn col-sm-4 mt-4 font22 text-uppercase mx-4"
      style="width:auto !important; padding-left:25px; padding-right:25px;"
      (click)="next();">Yes</button>
  </div>
</div>
<div class="container mobileview mb-3 px-0 pt-4">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="col-10 pull-right pl-4">
    <div class="col-12 px-0 pl-1">
      <label class="custom-control custom-checkbox chkbox mb-2" for="yes_id">
        <input type="checkbox" class="custom-control-input mgntp10" id="yes_id" value="isChecked"
          name="yes" [(ngModel)]="isChecked" (ngModelChange)="goNext();" />
        <label class="custom-control-label font20" for="yes_id">Yes</label>
      </label>
    </div>
  </div>
  <div style="width:100% !important; text-align: right;">
    <div *ngIf="isChecked" class="ash_box text-right mr-3">
      <h1 class="ansMob text-right">Yes, let's get started!</h1>
    </div>
  </div>
</div>